export enum ESitesOnboardingStatus {
    INVALID = 'Invalid',
    INPROGRESS = 'InProgress',
    COMPLETED = 'Completed'
}

export enum ESitesSyncStatus {
    UNAVAILABLE = 'SyncDataUnavailable',
    TRANSACTIONFAILED = 'SyncDataTranslationFailed',
    SITEFAILED = 'SiteCreationFailed',
    SYNCFAILED = 'ModelSyncFailed',
    STATUSFAILED = 'CommissioningStatusUpdateFailed'
}


export enum NODES_METADATA_FIELD {
    TIMEZONE= "TimeZone",
    LATITUDE= "Latitude",
    LONGITUDE= "Longitude",
    Currency="Currency",
    LegalConsent="LegalConsent"
}
export const formatCBFailedStatus: { [key: string]: string }[] = [
    { key: 'Failed,Failed to get customer offerings', value: 'Failed to get customer offerings' }   
];
